export default __webpack_public_path__ + "static/media/logo.a518669b.svg";